export default __webpack_public_path__ + "static/media/LexwareLogoBlack.c8231563.svg";